<h2 mat-dialog-title>Detalle Entrega</h2>
<mat-dialog-content class="mat-typography">



    <div class="timeline">
      <div class="timeline__group" *ngFor="let item of detalleLogWS">  

        <div class="timeline__box">
          <div class="timeline__date" [style.background-color]="item.codigoErrorWs == 0 ? green : red">
            <span class="timeline__day">
              <mat-icon style="color: white;" *ngIf="item.codigoErrorWs == 0">check_circle</mat-icon>
              <mat-icon style="color: white;" *ngIf="item.codigoErrorWs > 0">error</mat-icon>
            </span>
            <span class="timeline__month">Feb</span>
          </div>
          <div class="timeline__post">
            <div class="timeline__content">
              <span style="color: gray; font-weight:bolder;">{{item.fecha | date:'yyyy-MM-dd hh:mm:ss'}}</span>
              <p>{{item.descripcionErrorWs}}</p>
            </div>
          </div>
        </div>
        
      </div>      
    </div>

  


</mat-dialog-content>
<mat-dialog-actions align="end">  
  <button mat-raised-button color="primary" [mat-dialog-close]="dataModified" cdkFocusInitial>Cerrar</button>  
</mat-dialog-actions>